import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react-lite'
import MigrationsStore from './MigrationsStore'
import useStore from 'reusable/mobx-store-utils'
import { MigrationDto, MigrationType } from '@gap/backend/infra-services/migrations/models/MigrationType'
import SkeletonLoader from 'reusable/mui/skeleton/SkeletonLoader'
import { notNull } from '@gap/utils/utils'
import { capitalize } from 'reusable/utils/string-utils'
import { Link } from 'react-router-dom'
import DateUtils from '@gap/utils/date-utils'

export default observer(function Migrations() {
   const migrationsStore = useStore(() => new MigrationsStore())

   return <SkeletonLoader loading={!migrationsStore.migrations.data}>
      {migrationsStore.migrations.data && <>
         <MigrationTable migrations={notNull(migrationsStore.migrations.data).globalMigrations} destination="global" />
         <MigrationTable migrations={notNull(migrationsStore.migrations.data).regionalMigrations} destination="regional" />
      </>}
   </SkeletonLoader>
})

const MigrationTable = observer(function MigrationTable({ migrations, destination }: { migrations: MigrationDto[], destination: MigrationType['destination'] }) {
   return <Stack sx={{ gap: 2, mt: 2 }}>
      <Typography variant="h5">{capitalize(destination)} migrations</Typography>
      <Paper elevation={10}>
         <Stack direction="column" m={2}>
            <Table>
               <TableHead>
                  <TableRow>
                     <TableCell>Id</TableCell>
                     <TableCell>Date</TableCell>
                     <TableCell>Status</TableCell>
                     <TableCell>Last run</TableCell>
                     <TableCell>Ticket number</TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {migrations.map(migration => {
                     return <MigrationTableRow key={migration.id} migration={migration} />
                  })}
               </TableBody>
            </Table>
         </Stack>
      </Paper>
   </Stack>
})

const MigrationTableRow = observer(function MigrationTableRow({ migration }: { migration: MigrationDto }) {
   return <TableRow>
      <TableCell>{migration.id}</TableCell>
      <TableCell>{migration.createdAt ? DateUtils.formatDateTime(new Date(migration.createdAt)) : '—'}</TableCell>
      <TableCell>{migration.status} {migration.message && `(${migration.message})`}</TableCell>
      <TableCell>{migration.lastUpdatedAt ? DateUtils.formatDateTime(new Date(migration.lastUpdatedAt)) : '—'}</TableCell>
      <TableCell>
         <Link to={`https://dev.azure.com/thegap/The%20Gap%20App/_workitems/edit/${migration.ticketNumber}/`} target="_blank" rel="noopener noreferrer">
            <Typography sx={{ color: 'blue', textDecoration: 'underline' }}>{migration.ticketNumber}</Typography>
         </Link>
      </TableCell>
   </TableRow>
})
